import React, { useState, useRef } from 'react';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { useWatchlist } from '../context/WatchlistContext';
import WatchlistModal from './WatchlistModal';
import './WatchlistStar.css';

const WatchlistStar = ({ stock, size = '16px' }) => {
  const { isInWatchlist } = useWatchlist();
  const inWatchlist = isInWatchlist(stock.symbol);
  const [showModal, setShowModal] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);

  const handleClick = (e) => {
    e.stopPropagation();
    
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const modalWidth = 320;
      const modalHeight = 400;
      
      let top = rect.bottom + 8;
      let left = rect.left;
      
      if (left + modalWidth > window.innerWidth) {
        left = window.innerWidth - modalWidth - 16;
      }
      
      if (top + modalHeight > window.innerHeight) {
        top = rect.top - modalHeight - 8;
      }
      
      setModalPosition({ top, left });
    }
    
    setShowModal(true);
  };

  return (
    <>
      <button
        ref={buttonRef}
        className={`watchlist-star ${inWatchlist ? 'active' : ''}`}
        onClick={handleClick}
        title={inWatchlist ? 'Manage watchlists' : 'Add to watchlist'}
        style={{ fontSize: size }}
      >
        {inWatchlist ? (
          <FaStar className="star-icon filled" />
        ) : (
          <FaRegStar className="star-icon empty" />
        )}
      </button>
      
      {showModal && (
        <WatchlistModal
          stock={stock}
          onClose={() => setShowModal(false)}
          position={modalPosition}
        />
      )}
    </>
  );
};

export default WatchlistStar;
